import React, { useState, useEffect } from "react";

const safeSession = {
  get: (key: string) => {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set: (key: string, value: any) => {
    try {
      sessionStorage.setItem(key, value);
    } catch {}
  },
};

export const AllergyDisclaimerDialog = () => {
  const [visible, setVisible] = useState(() => {
    return safeSession.get("allergy_disclaimer_seen") !== "true";
  });
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (visible) setTimeout(() => setMounted(true), 10);
    else setMounted(false);
  }, [visible]);

  const handleClose = () => {
    safeSession.set("allergy_disclaimer_seen", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <style>{`
        .allergy-overlay {
          position: fixed; inset: 0;
          background: rgb(255 255 255 / 15%);
          backdrop-filter: blur(6px);
          display: flex; align-items: center; justify-content: center;
          z-index: 9999;
          padding: 1rem;
          transition: opacity 0.3s ease;
          opacity: 0;
        }
        .allergy-overlay.show { opacity: 1; }

        .allergy-card {
          background: #FDFAF5;
          border-radius: 20px;
          width: 100%; max-width: 400px;
          overflow: hidden;
          box-shadow: 0 32px 64px rgba(0,0,0,0.18);
          transform: translateY(24px) scale(0.97);
          transition: transform 0.4s cubic-bezier(0.16,1,0.3,1), opacity 0.3s ease;
          opacity: 0;
          font-family: 'DM Sans', sans-serif;
        }
        .allergy-card.show {
          transform: translateY(0) scale(1);
          opacity: 1;
        }

        .allergy-header {
          background: #013723;
          padding: 14px;
          position: relative;
        }
        .allergy-header-eyebrow {
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #bbd9ce;
          margin: 0 0 8px;
        }
        .allergy-header-title {
          font-family: 'DM Serif Display', Georgia, serif;
          font-size: 24px;
          color: #ebf0eeff;
          margin: 0;
          line-height: 1.2;
          font-weight: 400;
        }
        .allergy-header-icon {
          position: absolute; top: 24px; right: 24px;
          width: 40px; height: 40px;
          background: rgba(255,255,255,0.07);
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 18px;
        }

        .allergy-body {
          padding: 2px 15px 15px;
          background-color: #ecf1ef;
        }
        .allergy-desc {
          font-size: 14px;
          line-height: 1.75;
          color: #013723;
          margin: 0 0 20px;
        }

        .allergen-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
          margin-bottom: 20px;
        }
        .allergen-pill {
          display: flex; align-items: center; gap: 8px;
          background: #ddebe5;
          border: 1px solid #d2e4dc;
          border-radius: 10px;
          padding: 8px 12px;
          font-size: 13px;
          font-weight: 500;
          color: #013723;
        }
        .allergen-pill span:first-child { font-size: 16px; }

        .allergy-warning {
          background: #ddebe5;
          border: 1px solid #c5dbd2;
          border-left: 3px solid #549e83;
          border-radius: 10px;
          padding: 12px 14px;
          font-size: 13px;
          line-height: 1.65;
          color: #013723;
          margin-bottom: 0;
        }

        .allergy-footer {
          padding: 16px 28px 24px;
          position: relative;
          border-top:1px solid #97bfb18a;
          background-color: #d5e7e1cc;
        }
        .allergy-btn {
          width: 100%;
          background: #013723;
          color: #bbd9ce;
          border: none;
          border-radius: 12px;
          padding: 10px 16px;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          display: flex; align-items: center; justify-content: center; gap: 8px;
          transition: background 0.15s ease, transform 0.1s ease;
          letter-spacing: 0.01em;
        }
        .allergy-btn:hover { background: #2E2618; }
        .allergy-btn:active { transform: scale(0.98); }
        .allergy-btn-icon {
          width: 18px; height: 18px;
          background: rgba(255,255,255,0.15);
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 10px;
        }
      `}</style>

      <div className={`allergy-overlay ${mounted ? "show" : ""}`}>
        <div className={`allergy-card ${mounted ? "show" : ""}`}>
          <div className="allergy-header">
            <p className="allergy-header-eyebrow">Önemli Bilgi</p>
            <h2 className="allergy-header-title">
              Alerjen
              <br />
              Bilgilendirmesi
            </h2>
            <div className="allergy-header-icon">⚠️</div>
          </div>

          <div className="allergy-body">
            <p className="allergy-desc">
              Değerli misafirlerimiz, mutfağımızda gluten, süt, fındık gibi
              alerjen maddeler işlenmektedir. Ürünlerimizde çapraz bulaşma riski
              nedeniyle eser miktarda bu alerjenlerden bulunabileceğini
              dikkatinize sunarız.
            </p>

            <div className="allergy-warning">
              Ciddi bir gıda alerjiniz varsa lütfen sipariş vermeden önce servis
              personelini bilgilendiriniz.
            </div>
          </div>

          <div className="allergy-footer">
            <button className="allergy-btn" onClick={handleClose}>
              <span>Anladım. Devam et</span>
              <span className="allergy-btn-icon">✓</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
